module.exports = __webpack_public_path__ + "img/periodico.cd44ae90.jpg";